const captcha = {
  recaptcha:
    'La verificación de reCAPTCHA ha fallado. Por favor, inténtalo de nuevo.',
  recaptchaNotAvailable:
    'No se puede completar la verificación. Por favor, actualice la página e inténtelo de nuevo.',
  recaptchaInvalid: 'La verificación falló. Por favor, inténtelo de nuevo.',
  recaptchaUnexpected:
    'No se puede completar su solicitud. Por favor, inténtelo más tarde.',
};

export default captcha;
